import { GroupDivision } from "../shared/enums/GroupDivision";
import { SubDivision } from './SubDivision.model';

export class ConsultantSearch {
    _id: string[] = [];
    name: string = "";
    division: GroupDivision[] = [];
    subDivision: string = '';
    onlyActives: boolean = false;
    onlyInactives: boolean = false;
    onlyContractGenerated: boolean = false;
    onlyContractNotGenerated: boolean = false;
    responsible: string = '';
    email:String = "";
    kind: string = '';
    skip: number = 0;
    limit: number = 10;
    totalItems: number = 0;
    fields: string[] = [];
    companyName: string = "";
    excellenceCenter: string[] = [];
    supportCenter: Array<string> = [];
    cnpj: string = "";
}



// WEBPACK FOOTER //
// ./src/app/models/ConsultantSearch.model.ts